import { useEffect } from "react";
import { useFormikContext } from "formik";
import { scrollToElement } from "../../../helpers/scroll";

const OBJECT_DELIMITERS = ".";
const ARRAY_START_DELIMITER = "[";
const ARRAY_END_DELIMITER = "]";

const getFlattenKeysForObject = (target: {}): {} => {
  const output = {} as { [key: string]: string };

  function step(value: any, prev = "") {
    const type = Object.prototype.toString.call(value);
    const isObject = type === "[object Object]" || type === "[object Array]";
    const isArray = Array.isArray(value);

    if (!isArray && isObject) {
      Object.keys(value).forEach(function (key: string) {
        let newKey = prev ? prev + OBJECT_DELIMITERS + key : key;

        step(value[key], newKey);
      });
    } else if (isArray) {
      value.forEach((arrayValue: any, index: number) => {
        const arrayKey =
          prev + ARRAY_START_DELIMITER + index + ARRAY_END_DELIMITER;

        step(arrayValue, arrayKey);
      });
    } else {
      output[prev] = value;
    }
  }

  step(target);

  return output;
};

interface Props {
  offsetTop?: number;
}

const ScrollToError = ({ offsetTop = 140 }: Props) => {
  const { isSubmitting, isValidating, errors } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      const flattedErrors = getFlattenKeysForObject(errors);
      const errorKeys = Object.keys(flattedErrors);

      if (errorKeys.length > 0) {
        const selector = `[id="${errorKeys[0]}"], [name="${errorKeys[0]}"] `;
        const errorElement = document.querySelector(selector);

        if (errorElement) {
          scrollToElement(errorElement, offsetTop);
        }
      }
    }
  }, [isSubmitting, isValidating, errors]);

  return null;
};

export default ScrollToError;
